<template>
    <el-container class="my_container">
      <el-container>
        <el-aside >
          <SideNav />
        </el-aside>
        <el-main class="mnins">
          <el-header>
            <HeadBlock />
          </el-header>
          <AppMain />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import AppMain from './components/AppMain'
import SideNav from './components/SideNav'
import HeadBlock from './components/HeadBlock'
export default {
  name: 'Layout',
  components: {
    AppMain,
    HeadBlock,
    SideNav,
  }
}
</script>
<style lang="less" scoped>
  .mnins{
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/Layout/index.vue